const serviciosC = [
    {
      id: 1,
      name: "Catálogo 1",
      imgURL:
        "assets/img/cat1.png"
    },
    {
      id: 2,
      name: "Catálogo 2",
      imgURL:
        "assets/img/cat2.png"
    }
      ,
    {
      id: 3,
      name: "Catálogo 3",
      imgURL:
        "assets/img/cat3.png"
    },
    {
      id: 4,
      name: "Catálogo 4",
      imgURL:
        "assets/img/cat4.png"
    },
    {
      id: 5,
      name: "Catálogo 5",
      imgURL:
        "assets/img/cat5.png"
    },
    {
      id: 6,
      name: "Catálogo 6",
      imgURL:
        "assets/img/cat6.png"
    },
    {
      id: 7,
      name: "Catálogo 7",
      imgURL:
        "assets/img/cat7.png"
    },
    {
      id: 8,
      name: "Catálogo 8",
      imgURL:
        "assets/img/cat8.png"
    },
    {
      id: 9,
      name: "Catálogo 9",
      imgURL:
        "assets/img/cat9.png"
    },
    {
      id: 10,
      name: "Catálogo 10",
      imgURL:
        "assets/img/cat10.png"
    },
    {
      id: 11,
      name: "Catálogo 11",
      imgURL:
        "assets/img/cat11.png"
    },
    {
      id: 12,
      name: "Catálogo 12",
      imgURL:
        "assets/img/cat12.png"
    },
    {
      id: 13,
      name: "Tríptico 1",
      imgURL:
        "assets/img/tri1.png"
    },
    {
      id: 14,
      name: "Tríptico 2",
      imgURL:
        "assets/img/tri2.png"
    }
  ];
  
  export default serviciosC;